import { type } from "os";

export interface SummedData {
    onsite: SingleReport;
    remote: SingleReport;
    total: SingleReport;
    individual?: SingleReport;
}

export interface ReportLevels {
    individual: SingleReport,
    onsite: SingleReport,
    remote: SingleReport,
}

export interface SingleReport {
    documents: number;
    sessions: number;
    searches: number | string;
}

export const sumData = (result: { [key: string]: ReportLevels}, needIndividual = false): SummedData => {
    const keys = Object.keys(result)

    const onsiteSum: SingleReport = {
        sessions: 0,
        documents: 0,
        searches: "N/A"
    };

    const remoteSum: SingleReport = {
        sessions: 0,
        documents: 0,
        searches: "N/A"
    };

    const totalSum: SingleReport = {
        sessions: 0,
        documents: 0,
        searches: "N/A"
    };

    const individualSum: SingleReport = {
        sessions: 0,
        documents: 0,
        searches: "N/A"
    }

    if(SearchesAreNeeded(result)) {
        onsiteSum.searches = 0;
        remoteSum.searches = 0;
        totalSum.searches = 0;
        individualSum.searches = 0;
    }

    for(let j = 0; j < keys.length; j++) {
        const singleOnsite = result[keys[j]]?.onsite;
        const singleRemote = result[keys[j]]?.remote;
        const singleIndividual = result[keys[j]]?.individual;

        onsiteSum.sessions += singleOnsite.sessions;
        onsiteSum.documents += singleOnsite.documents;

        if(typeof(onsiteSum.searches) === "number") {
            onsiteSum.searches += singleOnsite.searches ? Number(singleOnsite.searches) : 0;
        }

        remoteSum.sessions += singleRemote.sessions;
        remoteSum.documents += singleRemote.documents;

        if(typeof(remoteSum.searches) === "number") {
            remoteSum.searches += singleRemote.searches ? Number(singleRemote.searches) : 0;
        }

        totalSum.sessions += singleOnsite.sessions + singleRemote.sessions;
        totalSum.documents += singleOnsite.documents + singleRemote.documents;

        if(typeof(remoteSum.searches) === "number" && typeof(totalSum.searches) === "number") {
            totalSum.searches += singleRemote.searches ? Number(singleRemote.searches) : 0;
        }

        if(typeof(onsiteSum.searches) === "number" && typeof(totalSum.searches) === "number") {
            totalSum.searches += singleOnsite.searches ? Number(singleOnsite.searches) : 0;
        }

        individualSum.sessions += singleIndividual.sessions;
        individualSum.documents += singleIndividual.documents;

        if(typeof(individualSum.searches) === "number") {
            individualSum.searches += singleIndividual.searches ? Number(singleIndividual.searches) : 0;
        }
    }

    if(needIndividual) {
        return {
            onsite: onsiteSum,
            remote: remoteSum,
            total: totalSum,
            individual: individualSum
        }
    }

    return {
        onsite: onsiteSum,
        remote: remoteSum,
        total: totalSum
    }
}

export const SearchesAreNeeded = (result: { [key: string]: ReportLevels }) => {
    const keys = Object.keys(result)

    if(keys && keys.length > 0) {
        const singleOnsite = result[keys[0]]?.onsite;
        const singleRemote = result[keys[0]]?.remote;
        const singleIndividual = result[keys[0]]?.individual;

        const condition = 
            typeof(singleOnsite.searches) !== "undefined"  
            && typeof(singleRemote.searches) !== "undefined" 
            && typeof(singleIndividual.searches) !== "undefined";

        return condition;
    }

    return false;
}

export const GetNeededValueForView = (searches: string | number) : string  => {
    const intl = new Intl.NumberFormat();

    if(typeof(searches) === "number") {
        return intl.format(searches);
    }

    return "N/A";
}